module.exports = __webpack_public_path__ + "img/constructionMachineryOtr.3070429c.jpg";